const LOG_MSGS = {
  init: (throttleMs) => `[ScrollTracker] Initializing with throttle: ${throttleMs}ms`,
  addListener: "[ScrollTracker] Adding scroll event listener",
  ready: "[ScrollTracker] Ready to track scroll events",
  log: (reason) => `[ScrollTracker] Logging: ${reason}`,
  pos: (scrollY, scrollX, scrollPercent, scrollEventCount, loggedEventCount) =>
    `[ScrollTracker] Position: Y=${scrollY}px, X=${scrollX}px, ${scrollPercent}% | Events: ${scrollEventCount} total, ${loggedEventCount} logged`,
  basicScroll: (scrollY, scrollX, scrollPercent) => `Scroll: Y=${scrollY}px, X=${scrollX}px, ${scrollPercent}%`,
  destroy: (scrollEventCount, loggedEventCount) =>
    `[ScrollTracker] Destroying - Final stats: ${scrollEventCount} total events, ${loggedEventCount} logged events`,
  listenerRemoved: "[ScrollTracker] Event listener removed",
  extremePos: (isAtTop) => `extreme position (${isAtTop ? "top" : "bottom"})`,
  throttlePassed: (timeSinceLastUpdt, throttleMs) => `throttle passed (${timeSinceLastUpdt}ms >= ${throttleMs}ms)`,
};

class ScrollTracker {
  constructor(config = {}) {
    const { throttleMs = 12.5, log = false } = config;

    this.log = log;
    this.throttleMs = throttleMs;
    this.el_body = document.body;

    if (this.log) console.log(LOG_MSGS.init(throttleMs));
    this.lastUpdte = 0;
    this.scrollEventCount = 0;
    this.loggedEventCount = 0;
    this.init();
  }

  init() {
    if (this.log) console.log(LOG_MSGS.addListener);
    window.addEventListener("scroll", this.hdl_scroll.bind(this), { passive: true });
    if (this.log) console.log(LOG_MSGS.ready);
  }

  hdl_scroll() {
    // Setup //
    const el_body = this.el_body;
    this.scrollEventCount++;
    const now = Date.now();
    const timeSinceLastUpdt = now - this.lastUpdte;

    // Measure footer el. height
    const el_footer = document.querySelector("[data-widget_type='ave-gastro-footer.default']");
    const h_footer = el_footer?.offsetHeight || 0;

    // Check if we're at extreme positions (top or bottom)
    const scrollY = window.scrollY || window.pageYOffset;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const scrollProgress = (scrollY / maxScroll) * 100;
    const isAtTop = scrollY === 0;
    const is_nearTop = scrollY < 100;
    const is_nearBottom = scrollY >= maxScroll - h_footer;
    const isAtBottom = scrollY >= maxScroll;
    const isAtExtreme = isAtTop || isAtBottom;

    if (timeSinceLastUpdt >= this.throttleMs || isAtExtreme) {
      if (this.log) {
        const reason = isAtExtreme ? LOG_MSGS.extremePos(isAtTop) : LOG_MSGS.throttlePassed(timeSinceLastUpdt, this.throttleMs);
        console.log(LOG_MSGS.log(reason));
        this.log_scrollPos();
      }

      el_body.style.setProperty("--scroll-prog", scrollProgress + "%");
      el_body.dataset.nearTop = is_nearTop;
      el_body.dataset.nearBottom = is_nearBottom;
      this.lastUpdte = now;
      this.loggedEventCount++;
    }
  }

  log_scrollPos() {
    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;
    const scrollPercent = Math.round((scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100);

    if (this.log) {
      console.log(LOG_MSGS.pos(scrollY, scrollX, scrollPercent, this.scrollEventCount, this.loggedEventCount));
    }
  }

  destroy() {
    if (this.log) console.log(LOG_MSGS.destroy(this.scrollEventCount, this.loggedEventCount));
    window.removeEventListener("scroll", this.hdl_scroll);
    if (this.log) console.log(LOG_MSGS.listenerRemoved);
  }
}

export default ScrollTracker;
